// extracted by mini-css-extract-plugin
module.exports = {"container":"ZoomableImage_container__Pfksz","isZoomed":"ZoomableImage_isZoomed__Zab0p","image":"ZoomableImage_image__go6eR"};